import classnames from "classnames";

/**
 * className and onClick of a community row or card that opens details:
 * gets the clickable modifier only when there is a handler.
 *
 * @param {((item: object) => void) | undefined} onClick
 * @param {object} item row data passed to the handler
 * @param {string | string[]} baseClass
 * @param {string} clickableClass
 */
export const getClickableProps = (onClick, item, baseClass, clickableClass) => ({
  className: classnames(baseClass, { [clickableClass]: onClick }),
  onClick: onClick ? () => onClick(item) : undefined,
});
